import { Box, HStack, VStack } from '@chakra-ui/react';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import React from 'react';
import { Image, ImageMap } from '@common/components/Image';
import { SFRRoadMapStep } from '@services/appsync/types';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { SectionHeader } from '../common/SectionHeader';

export const Roadmap: React.FC = () => {
  const { property } = usePropertiesModel();
  const roadMap = property?.sfr?.status.road_map;

  if (!roadMap || roadMap.length === 0) return null;
  return (
    <VStack alignItems={['center', 'flex-start']}>
      <Box alignSelf={'flex-start'} mb={['20px', '40px']}>
        <SectionHeader text={'Investment Roadmap'} />
      </Box>
      <VStack gap="0px" alignItems="flex-start">
        {roadMap.map((item, i) => {
          let icon: keyof typeof ImageMap, title: string;

          switch (item.step) {
            case SFRRoadMapStep.SOURCING:
              icon = 'house-search-icon';
              title = 'Sourcing';
              break;
            case SFRRoadMapStep.ACQUISITION:
              icon = 'deal-icon';
              title = 'Acquisition';
              break;
            case SFRRoadMapStep.IMPROVEMENT:
              icon = 'construction-icon';
              title = 'Property Improvements';
              break;
            case SFRRoadMapStep.LEASE_UP:
              icon = 'contract-icon';
              title = 'Lease Up';
              break;
            case SFRRoadMapStep.MANAGING:
              icon = 'call-center-icon';
              title = 'Managing';
              break;
            case SFRRoadMapStep.DISPOSITION:
              icon = 'sold-sign-icon';
              title = 'Disposition';
              break;
          }

          return (
            <HStack
              key={`roadmap-item-${i}`}
              alignItems="stretch"
              justifyContent="flex-start"
              gap="15px"
              style={{
                margin: '0',
                padding: '0',
              }}>
              <Box display="flex" alignItems="center">
                <Box
                  w="2px"
                  h="100%"
                  background={
                    i === 0
                      ? 'linear-gradient(0deg, black 20%, white 100%)'
                      : roadMap && i === roadMap.length - 1
                      ? 'linear-gradient(180deg, black 0%, white 100%)'
                      : 'linear-gradient(180deg, black 0%, black 100%)'
                  }></Box>
                <Box backgroundColor="blue.500" w="8px" h="8px" ml="-5px" borderRadius={'8px'} alignSelf="center" />
              </Box>
              <Box display="flex" alignItems={'center'}>
                <Image image={icon} alt={title} minW={'64px'} />
              </Box>
              <Box py="15px">
                <TextBlock fontSize="20px" weight="bold">
                  {title}
                </TextBlock>
                <TextBlock fontSize="16px" color="gray.500">
                  {item.description}
                </TextBlock>
              </Box>
            </HStack>
          );
        })}
      </VStack>
    </VStack>
  );
};
